<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height>
          <v-flex xs12 sm12 md12>
        <v-flex xs12 sm12 md12>
          <div class="display-2 text-xs-center primary--text">Page Not Found! You should go home!</div>
        </v-flex>
        <v-flex justify-center align-center xs12 sm12 md12>
        <div class="text-xs-center mt-4">
              <router-link :to="{ name: 'DashBoard'}">
               <v-btn round color="primary" dark>
                   Return to home
                </v-btn>
                </router-link>
           </div>
         <div class="text-xs-center mt-4">{{ app_name }} Powered By 
         <a :href="'//' + company_website" target="_blank">
          {{ company_name }}
        </a>
         </div>
          </v-flex>
          </v-flex>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import global from '@/components/rbconstants';
  export default {
    data: () => ({
      app_name : global.app_name,
      company_website : global.company_website,
      company_name : global.company_name,
    }),
  }
</script>
